import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Image from "../components/image"
import LogoImg from "../components/image_logo"
import "./layout_test.css"

const linkStyle = {
  color: `black`,
  textDecoration: `none`,
}
const activeLinkStyle = {
  color: `black`,
  fontWeight: 700,
  textDecoration: 'none',
  borderBottom: '5px solid black',
}


const HeaderSmall = ( {StrPart1, StrPart2} ) => {

    return (
      <header
        style={{
          background: `white`,
          marginBottom: `0em`,
        }}
      >
        <div
          style={{
            margin: `0px 0px 0px 0px`,
            maxWidth: '0',
            padding: `60px 0px 0px 12%`,
          }}
        >
          <table style={{margin: '0px 0px 0px 0px',
            border: '0px solid black',
            borderCollapse: 'collapse'}}>
            <tbody>
            <tr>
              <td style={{border: '0px solid black',
                borderCollapse: 'collapse'}}>
                <Link to="/" style={linkStyle}>
                  <div style={{width:'300px'}}><LogoImg/></div>
                </Link>
              </td>
              <td style={{border: '0px solid black',
                borderCollapse: 'collapse',
                padding: '1.5em 0px 0px 10em',
                fontWeight: '400',
                fontSize: '1rem',
                whiteSpace: 'nowrap'}}>

                <Link to="/about" style={linkStyle} activeStyle={activeLinkStyle}>Über uns</Link>
              </td>
              <td style={{border: '0px solid black',
                borderCollapse: 'collapse',
                padding: '1.5em 0px 0px 1em',
                fontWeight: '400',
                fontSize: '1rem',
                whiteSpace: 'nowrap'}}>

                <Link to="/goals" style={linkStyle} activeStyle={activeLinkStyle}>Unser Ziel</Link>
              </td>
              <td style={{border: '0px solid black',
                borderCollapse: 'collapse',
                padding: '1.5em 0px 0px 1em',
                fontWeight: '200',
                fontSize: '1rem',
                whiteSpace: 'nowrap',
                color: 'gray'}}>
                Leaks finden
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div style={{height: '34px', margin: `0px 0px 0px 0px` }}>
          <Image />
        </div>
      </header>
    )

}

HeaderSmall.propTypes = {
  StrPart1: PropTypes.string,
  StrPart2: PropTypes.string,
}

HeaderSmall.defaultProps = {
  StrPart1: ``,
  StrPart2: ``,
}

export default HeaderSmall
